import { BannerRequestBody } from 'api/Banner/types'

// Query key factory for Distribution Analysis
export const distributionAnalysisKeys = {
    all: ['distributionAnalysis'] as const,
    performanceFacts: (orgId: string, params: BannerRequestBody) =>
        [
            ...distributionAnalysisKeys.all,
            'performanceFacts',
            orgId,
            params,
        ] as const,
    overview: (orgId: string, params: BannerRequestBody) =>
        [...distributionAnalysisKeys.all, 'overview', orgId, params] as const,
    overviewBreakdown: (orgId: string, params: BannerRequestBody) =>
        [
            ...distributionAnalysisKeys.all,
            'overviewBreakdown',
            orgId,
            params,
        ] as const,
    overviewTopSellers: (orgId: string, params: BannerRequestBody) =>
        [
            ...distributionAnalysisKeys.all,
            'overviewTopSellers',
            orgId,
            params,
        ] as const,
    sellerList: (orgId: string, params: BannerRequestBody) =>
        [...distributionAnalysisKeys.all, 'sellerList', orgId, params] as const,
    sellerDrawerSellerProducts: (orgId: string, params: BannerRequestBody) =>
        [
            ...distributionAnalysisKeys.all,
            'sellerDrawerSellerProducts',
            orgId,
            params,
        ] as const,
    sellerDrawerSellerProductsInvalidationKey: (orgId: string) =>
        [
            ...distributionAnalysisKeys.all,
            'sellerDrawerSellerProducts',
            orgId,
        ] as const,
    buyBoxAllOffers: (orgId: string, params: BannerRequestBody) =>
        [
            ...distributionAnalysisKeys.all,
            'buyBoxAllOffers',
            orgId,
            params,
        ] as const,
    buyBoxAllOffersInvalidationKey: (orgId: string) =>
        [...distributionAnalysisKeys.all, 'buyBoxAllOffers', orgId] as const,
    suppressedBuyBoxBreakdown: (orgId: string, params: BannerRequestBody) =>
        [
            ...distributionAnalysisKeys.all,
            'suppressedBuyBoxBreakdown',
            orgId,
            params,
        ] as const,
    mapViolations: (orgId: string, params: BannerRequestBody) =>
        [
            ...distributionAnalysisKeys.all,
            'mapViolations',
            orgId,
            params,
        ] as const,
}
